// let eventQueue = [];

// // 무조건 즉시 이벤트 리스너 등록
// let trackAutoBind = (getUserId) => {
//     document.addEventListener(
//         "click",
//         (e) => {
//             const el = e.target.closest("[data-track]");
//             // if (!el || el.dataset.track.includes("googleLogin")) return;
//             if (!el) return;

//             const data = {
//                 user_id: getUserId(), // "guest" OK, but better to omit if not logged in
//                 target: el.dataset.track,
//             };

//             if (window.gtagReady) {
//                 track(data);
//             } else {
//                 eventQueue.push(data);
//             }
//         },
//         true
//     );

//     window.gtagReady = false;
// };

// let track = (data, callback) => {
//     const device = window.innerWidth > 800 ? "desktop" : "mobile";

//     if (typeof gtag === "function") {
//         const params = {
//             ui_component: data.target,
//             device_type: device,
//             // user_id는 로그인 시에만 전달 (익명성 보장)
//         };
//         if (data.user_id && data.user_id !== "guest") {
//             params.user_id = data.user_id;
//         }

//         gtag("event", "ui_click", params, {
//             event_callback: () => {
//                 callback?.();
//                 window.gtagReady = true;
//                 // 큐 처리
//                 while (eventQueue.length) {
//                     track(eventQueue.shift());
//                 }
//             },
//         });
//     } else {
//         callback?.();
//     }
// };

let track = (data, callback) => {
    let device = window.innerWidth > 800 ? "desktop" : "mobile";
    let info =
        "uid=" +
        data.user_id +
        "&target=" +
        data.target +
        "&device=" +
        device +
        "&ts=" +
        Date.now();

    // console.log("Tracking Event:", info);

    // gtag가 로드되어 있는지 확인 후 호출
    if (typeof gtag !== "undefined") {
        gtag("event", "click", {
            event_label: info,
            event_callback: () => {
                if (callback) {
                    callback();
                }
            },
        });
    } else {
        // gtag가 없는 경우 바로 콜백 실행
        if (callback) {
            callback();
        }
    }
};

// let trackAutoBind = (getUserId) => {
//     document.addEventListener(
//         "click",
//         (e) => {
//             const el = e.target.closest("[data-track]");
//             if (!el) return;
//             // if (el.dataset.track.includes("googleLogin")) return;

//             track({
//                 user_id: getUserId(),
//                 target: el.dataset.track,
//             });
//         },
//         true
//     );
// };

let trackAutoBind = (getUserId) => {
    const attachListener = () => {
        document.addEventListener(
            "click",
            (e) => {
                const el = e.target.closest("[data-track]");
                if (!el) return;
                if (el.dataset.track.includes("googleLogin")) return;

                track({
                    user_id: getUserId(),
                    target: el.dataset.track,
                });
            },
            true
        );
    };

    // gtag가 있으면 바로, 없으면 대기
    if (typeof gtag !== "undefined") {
        attachListener();
    } else {
        // gtag.js 로드 완료 대기 (polling or DOM-ready 보장)
        const checkGtag = () => {
            if (typeof gtag !== "undefined") {
                attachListener();
            } else {
                setTimeout(checkGtag, 100); // 100ms마다 확인
            }
        };
        checkGtag();
    }
};

let showDropDown = (e) => {
    let getCustomSelect = document.getElementsByClassName("customSelect");
    let currentTarget = e.currentTarget;
    for (let i = 0; i < getCustomSelect.length; i++) {
        if (currentTarget.isEqualNode(getCustomSelect[i])) {
            continue;
        }

        let getMoreVert = getCustomSelect[i].lastChild;
        getMoreVert.style.display = "none";
    }

    let getMoreVert = currentTarget.lastChild;
    if (getMoreVert.style.display === "none") {
        getMoreVert.style.display = "block";
    } else {
        getMoreVert.style.display = "none";
    }
};

let hideMoreVert = (e) => {
    let getMoreVert = document.getElementsByClassName("moreVert");

    for (let i = 0; i < getMoreVert.length; i++) {
        if (
            getMoreVert[i].style.display == "block" &&
            !getMoreVert[i].contains(e.target)
        ) {
            getMoreVert[i].style.display = "none";
        }
    }
};

document.addEventListener("click", hideMoreVert);

let hideDialog = () => {
    document.addEventListener("click", (e) => {
        let getDialog = document.getElementsByTagName("dialog");
        for (let i = 0; i < getDialog.length; i++) {
            getDialog[i].addEventListener("click", (e) => {
                if (e.target.nodeName === "DIALOG") {
                    getDialog[i].close();
                }
            });
        }
    });
};

export { track, trackAutoBind, showDropDown, hideMoreVert, hideDialog };
